/**
 * Libellés lisibles pour `litiges.admin_decision` (valeurs API : refund | release).
 * @param {string|null|undefined} decision
 * @returns {string}
 */
export function litigeDecisionExplainedFr(decision) {
  const d = String(decision || "").trim().toLowerCase();
  if (d === "refund") {
    return "Remboursement de l’acheteur : l’argent lui est restitué ; le vendeur ne perçoit pas cette vente.";
  }
  if (d === "release") {
    return "Paiement au vendeur : les fonds lui sont versés ; l’acheteur n’est pas remboursé.";
  }
  const raw = String(decision || "").trim();
  return raw || "—";
}

/** Décision IA à la clôture d’appel (`ai_analysis.decision` côté transaction). */
export function aiCallClosureDecisionHeadlineFr(decision) {
  const d = String(decision || "").trim().toLowerCase();
  if (d === "buyer_refund") {
    return "Remboursement en faveur de l’acheteur (refus retenu ou règle plateforme).";
  }
  if (d === "seller_capture") {
    return "Versement au vendeur (refus non retenu par l’analyse de l’appel).";
  }
  if (d === "litige_gray_zone_prospect") {
    return "Zone grise : examen manuel recommandé (prospect / fiche ambigus).";
  }
  if (d === "rdv_confirmed") {
    return "RDV confirmé par l’acheteur — fonds libérés au vendeur.";
  }
  if (d === "platform_violation_contact_harvest") {
    return "Anti-contournement : coordonnées hors plateforme détectées.";
  }
  const raw = String(decision || "").trim();
  return raw ? `Décision enregistrée : ${raw}` : null;
}

export function aiCallClosureDecisionShortFr(decision) {
  const d = String(decision || "").trim().toLowerCase();
  if (d === "buyer_refund") return "Remboursement acheteur";
  if (d === "seller_capture") return "Versement vendeur";
  if (d === "litige_gray_zone_prospect") return "Zone grise";
  if (d === "rdv_confirmed") return "RDV confirmé";
  if (d === "platform_violation_contact_harvest") return "Anti-contournement";
  const raw = String(decision || "").trim();
  return raw || null;
}

/** Phrase courte pour badges / résumés (admin). */
export function litigeDecisionShortFr(decision) {
  const d = String(decision || "").trim().toLowerCase();
  if (d === "refund") return "Remboursement acheteur";
  if (d === "release") return "Paiement vendeur";
  const raw = String(decision || "").trim();
  return raw || "—";
}
